import { createSlice } from "@reduxjs/toolkit";

const loadFromLocalStorage = () => {
  const savedState = localStorage.getItem("badgeSwitchState");

  return savedState ? JSON.parse(savedState) : null;
};

const initialState = loadFromLocalStorage() || {
  items: [],
  selectedId: null,
};

const saveToLocalStorage = (state) => {
  localStorage.setItem("badgeSwitchState", JSON.stringify(state));
};

export const badgeSwitchSlice = createSlice({
  name: "badgeSwitch",
  initialState,
  reducers: {
    setBadgeSwitchItems: (state, action) => {
      state.items = action.payload;
      saveToLocalStorage(state);
    },
    setSelectedBadgeItemId: (state, action) => {
      state.selectedId = action.payload;
      saveToLocalStorage(state);
    },
  },
});

export const getBadgeSwitchItems = (state) => state.badgeSwitch.items;
export const getSelectedBadgeItemId = (state) => state.badgeSwitch.selectedId;

export const getSelectedBadgeItem = (state) => {
  const items = state.badgeSwitch.items;
  const selectedId = state.badgeSwitch.selectedId;

  if (!items.length || !selectedId) {
    return null;
  }

  return items.find((item) => item.id === selectedId);
};

export const { setBadgeSwitchItems, setSelectedBadgeItemId } = badgeSwitchSlice.actions;

export default badgeSwitchSlice.reducer;
